<p-tabView [(activeIndex)]="activeTabIndex" (onChange)="onTabChange($event)">
	<p-tabPanel *ngFor="let tab of tabs" [header]="tab.label"></p-tabPanel>
</p-tabView>
<router-outlet></router-outlet>
